import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { useSelector } from 'react-redux';

import {
  useSortable,
} from '@dnd-kit/sortable';

import Photo from './Photo';

const useMountStatus = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), 500);

    return () => clearTimeout(timeout);
  }, []);

  return isMounted;
};

const SortableItem = ({
  item,
  isSelected,
  onSelect,
  // onEditClicked,
  // onRemove,
  isDropped,
  id,
  index,
  handle,
  renderItem,
  style,
  containerId,
  getIndex,
  wrapperStyle,
}) => {
  // const isBusy = useSelector(state => state?.listing?.isBusy ?? false);
  const {
    setNodeRef,
    listeners,
    isDragging,
    isSorting,
    over,
    overIndex,
    transform,
    transition,
  } = useSortable({
    id: item.id,
    // disabled: isBusy,
  });
  const mounted = useMountStatus();
  const mountedWhileDragging = isDragging && !mounted;
  const newlisteners = {
    ...listeners,
    onClick: event => {
      onSelect(item, event.ctrlKey);
    },
  };
  const className = classNames(
    isSelected && 'selectedItem',
    isDropped && 'droppedItem',
  );

  return (
    <Photo
      item={item}
      ref={setNodeRef}
      className={className}
      value={item.id}
      dragging={isDragging}
      sorting={isSorting}
      handle={handle}
      index={index}
      wrapperStyle={wrapperStyle({ index })}
      style={style({
        index,
        value: id,
        isDragging,
        isSorting,
        overIndex: over ? getIndex(over.id) : overIndex,
        containerId,
      })}
      // onEditClicked={onEditClicked}
      // onRemove={onRemove}
      transition={transition}
      transform={transform}
      fadeIn={mountedWhileDragging}
      listeners={newlisteners}
      renderItem={renderItem}
    />
  );
};

SortableItem.propTypes = {
  isSelected: PropTypes.bool,
  item: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
  onSelect: PropTypes.func,
  isDropped: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  index: PropTypes.number,
  style: PropTypes.func,
  containerId: PropTypes.string,
  getIndex: PropTypes.func,
  handle: PropTypes.bool,
  renderItem: PropTypes.arrayOf(PropTypes.string, PropTypes.shape()),
  // onRemove: PropTypes.func,
  // onEditClicked: PropTypes.func,
  wrapperStyle: PropTypes.func,
};

export default SortableItem;
